import React from "react";
import { Box, SvgIcon } from "@mui/material";

export const LastNodeLevelIcon = (props) => (
    <Box
        sx={{
            width: '32px',
            height: '32px',
            background: 'transparent',
            borderRadius: '6.2px',

        }}
    >
        <SvgIcon viewBox="0 0 12 50" sx={{ width: 'auto', ...props }}>
            <path
                d="M0.579406 16.4357L0.829406 16.4357V16.4357L0.579406 16.4357ZM9.16545 19.4C9.16545 20.1363 9.7624 20.7333 10.4988 20.7333C11.2352 20.7333 11.8321 20.1363 11.8321 19.4C11.8321 18.6636 11.2352 18.0666 10.4988 18.0666C9.7624 18.0666 9.16545 18.6636 9.16545 19.4ZM0.329346 7.54297L0.329406 16.4357L0.829406 16.4357L0.829346 7.54297L0.329346 7.54297ZM0.329406 16.4357C0.329391 16.8552 0.329012 17.2686 0.375399 17.6441C0.422013 18.0215 0.517906 18.3821 0.724526 18.6918C1.14948 19.3288 1.96803 19.65 3.40447 19.65V19.15C2.01579 19.15 1.42178 18.836 1.14046 18.4143C0.993949 18.1947 0.913283 17.9201 0.871628 17.5828C0.829747 17.2438 0.829391 16.8631 0.829406 16.4357L0.329406 16.4357ZM3.40447 19.65H10.4988V19.15H3.40447V19.65Z"
                fill="#BBBBBB"
            />
            {/* <path
                d="M0.539062 0V18.3244"
                stroke="#BBBBBB"
                strokeWidth="0.5"
            /> */}
        </SvgIcon>
    </Box>
);
